/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegionsControllerFindAllQueryResponse, RegionsControllerFindAllQueryParams, RegionsControllerFindAll401, RegionsControllerFindAll403 } from "../../models/regionsController/RegionsControllerFindAll";

function getRegionsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/regions` as const }  
  return res
}

/**
 * @summary Get all regions
 * {@link /api/v1/regions}
 */
export async function regionsControllerFindAll(params?: RegionsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RegionsControllerFindAllQueryResponse, ResponseErrorConfig<RegionsControllerFindAll401 | RegionsControllerFindAll403>, unknown>({ method : "GET", url : getRegionsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}